 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import axios from '../../config/axios'
import axiosskillmeo from '../../config/skillmeoaxios'
import axiosmooc from '../../config/moocaxios'
import axiossocial from '../../config/socialaxios'
import { setSocialUserInfo } from '../user_info_storage'
const apiGetInfo = async () => {
	try {
		const result = await axios.get(`/user/me`, {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("token"),
			}
		})
		localStorage.setItem('user_info', JSON.stringify(result.data))
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _ => _.response, 'optionalAccess', _2 => _2.data]);
	}
}

const apiGetSearchUser = async (keyword = "") => {
	try {
		const result = await axiossocial.get(`/relation/friend/search`, {
			params: { keyword }
		});
		return result;
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _3 => _3.response, 'optionalAccess', _4 => _4.data]) || { error: "Unknown error" };
	}
};

const apiGetSocialInfo = async () => {
	try {
		const result = await axiossocial.get(`/user/me`, {})
		setSocialUserInfo(result.data)
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _5 => _5.response, 'optionalAccess', _6 => _6.data]);
	}
}
const apiGetInfoMooc = async () => {
	try {
		const result = await axiosmooc.get(`/v1/user/info`, {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("mooc_token"),
			}
		})
		localStorage.setItem('mooc_user_info', JSON.stringify(result.data))
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _7 => _7.response, 'optionalAccess', _8 => _8.data]);
	}
}

const apiGetInfoSkillmeo = async () => {
	try {
		const result = await axiosskillmeo.get(`/user/my`, {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("skillmeo_token"),
			}
		})
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _9 => _9.response, 'optionalAccess', _10 => _10.data]);
	}
}

const apiResetPassword = async (Values) => {
	try {
		const result = await axios.put(`/v1/user/auth/me`, Values, {})
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _11 => _11.response, 'optionalAccess', _12 => _12.data]);
	}
}

const apiEditProfile = async (Values) => {
	try {
		const result = await axios.put(`/user/update`, Values, {})
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _13 => _13.response, 'optionalAccess', _14 => _14.data]);
	}
}
const apiEditProfileMooc = async (Values) => {
	try {
		const result = await axiosmooc.put(`/v1/user/account/my`, Values, {})
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _15 => _15.response, 'optionalAccess', _16 => _16.data]);
	}
}

const apiUploadFileMooc = async (file) => {

	try {
  
	  let formData = new FormData()
	  formData.append('filelist', '["tmp_file"]')
	  formData.append('tmp_file', file);
  
	  const result = await axiosmooc.post(`/v1/upload/public`, formData, {
	  })
	  return result
	} catch (error) {
	  return _optionalChain([error, 'optionalAccess', _17 => _17.response, 'optionalAccess', _18 => _18.data]);
	}
  }
  

const apiUploadProfilePicture = async (Values) => {
	try {
		const result = await axios.post(`/user/update/profile_picture`, Values, {})
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _19 => _19.response, 'optionalAccess', _20 => _20.data]);
	}
}

const apiAddUser = async (Values) => {
	try {
		const result = await axios.post(`/v1/user`, Values, {})
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _21 => _21.response, 'optionalAccess', _22 => _22.data]);
	}
}

const apiEditUserPasswordMooc = async (Values) => {
	const result = await axiosmooc.put(`/v1/user/auth/my/password`, Values, {})
	return result
}

const apiGetProfileTemplatePrivacy = async () => {
	try {
		const result = await axiosskillmeo.get('/user/profile/template_privacy', {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('skillmeo_token'),
			},
		})
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _23 => _23.response, 'optionalAccess', _24 => _24.data]);
	}
}

const apiUpdateProfileTemplatePrivacy = async (payload) => {
	try {
		const result = await axiosskillmeo.patch('/user/profile/privacy', payload, {})
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _25 => _25.response, 'optionalAccess', _26 => _26.data]);
	}
}

export {
	apiGetInfo,
	apiGetSocialInfo,
	apiResetPassword,
	apiEditProfile,
	apiAddUser,
	apiEditUserPasswordMooc,
	apiGetInfoSkillmeo,
	apiGetInfoMooc,
	apiUploadProfilePicture,
	apiEditProfileMooc,
	apiGetProfileTemplatePrivacy,
	apiUpdateProfileTemplatePrivacy,
	apiUploadFileMooc,
	apiGetSearchUser
}
